export default __webpack_public_path__ + "static/media/pexels-thirdman-5327914.437bc216.jpg";